/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
  Modal,
  DatePicker,
  TreeSelect,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import {
  getAreas,
  getCuentasContables,
  getEstadosGlobales,
  getFuentesDeFinanciamiento,
} from 'api/catalogos';
import Table from 'components/Table';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceived } from 'utils/formatValues';
import moment from 'moment/moment';
import { getClasificadoresObjetoGasto } from 'api/configuraciones/clasificadorObjetoGasto';
import { getClasificacionesTipoGasto } from 'api/catalogos/ClasificacionTipoGasto';
import { getProyectoPresupuestales } from 'api/catalogos/ProyectoPresupuestal';
import {
  autorizarCuentaContableIPEJAL,
  deleteCuentaContableIPEJAL,
  getCuentaContableIPEJAL,
  getCuentasContablesIPEJAL,
  patchCuentaContableIPEJAL,
  postCuentaContableIPEJAL,
} from 'api/nominas/cuentaContableIPEJAL';
import { getCuentaContable } from 'api/catalogos/CuantasContables';
import { normalizeData } from 'utils/normalizers';
/** cambiarlo en qa */
export const CuentaContableIPEJALPermission = {
  permissionModel: 'cargadereporte',
  catalogsModels: [],
  tabsModels: [],
};

const CuentaContableIPEJAL = ({ permission, idFather }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [areas, setAreas] = useState([]);
  const [cuentasContables, setCuentasContables] = useState([]);

  const formInstances = [
    form,
  ];
  const normalizeDataAreas = (_areasFetchArray) => {
    const mainMap = new Map();
    _areasFetchArray.forEach((item) => {
      mainMap.set(item.id, { ...item, children: [] });
    });

    const result = [];

    _areasFetchArray.forEach((item) => {
      if (item.directorio_area_padre) {
        const parent = mainMap.get(item.directorio_area_padre);
        if (parent) {
          parent.children.push(mainMap.get(item.id));
        }
      } else {
        result.push(mainMap.get(item.id));
      }
    });

    const sortByClave = (nodes) => {
      nodes.sort((a, b) => a.clave.localeCompare(b.clave));
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          sortByClave(node.children);
        }
      });
    };

    sortByClave(result);

    return result;
  };

  // Esta función adapta el árbol para que funcione con TreeSelect
  const formatTreeSelectData = (nodes) => nodes.map((node) => ({
    title: `${node.clave} - ${node.nombre.trim()}`,
    value: node.id,
    children: node.children ? formatTreeSelectData(node.children) : [],
  }));

  const removeEmptyChildren = (node) => {
    if (!node.children || node.children.length === 0) {
      return { ...node, children: undefined };
    }

    return {
      ...node,
      children: node.children.map(removeEmptyChildren),
    };
  };
  const normalize = (_data) => {
    const nodeMap = new Map();

    _data.forEach((node) => {
      nodeMap.set(node.id, {
        ...node,
        children: [],
        key: `${node.id}`, // clave única para antd Table
      });
    });
    const roots = [];
    _data.forEach((node) => {
      const currentNode = nodeMap.get(node.id);
      if (node.cuenta_padre) {
        const parent = nodeMap.get(node.cuenta_padre);
        if (parent) {
          parent.children.push(currentNode);
        }
      } else {
        roots.push(currentNode);
      }
    });

    return roots.map(removeEmptyChildren);
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getCuentasContablesIPEJAL({ tasas_ipejal: idFather[0] });
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _areas,
        _cuentasContables,
        _data,
      ] = await Promise.all([
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getCuentasContables(),
        getCuentasContablesIPEJAL({ tasas_ipejal: idFather[0] }),
      ]);
      if (mounted) {
        const formattedURS = formatTreeSelectData(normalizeDataAreas(_areas));
        setAreas(formattedURS);
        const normalized = normalize(_cuentasContables);
        setCuentasContables(normalized);
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const mapToTreeData = (nodes) => nodes.map((node) => {
    const isLeaf = !node.children || node.children.length === 0;

    return {
      title: `${node.clave_visible || node.clave} - ${node.nombre}`,
      value: node.id,
      key: node.id,
      disabled: !isLeaf, //  Deshabilita si no es hoja
      children: node.children ? mapToTreeData(node.children) : undefined,
    };
  });

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.find((item) => item.id === key);
    const _percepcionesConfigIPEJAL = await getCuentaContableIPEJAL(match.id);

    setTimeout(() => {
      if (_percepcionesConfigIPEJAL) {
        const formValues = {
          ...formatReceived(_percepcionesConfigIPEJAL),
          area: _percepcionesConfigIPEJAL.area.id,
          cuenta_contable: _percepcionesConfigIPEJAL.cuenta_contable.id,
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      const _tasa_ipejal = idFather[0];
      values.tasa_ipejal = _tasa_ipejal;
      const saved = await (key ? patchCuentaContableIPEJAL(key, values) : postCuentaContableIPEJAL(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteCuentaContableIPEJAL(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Incidencia Validacion ya autorizado');
        return;
      }
      const saved = await autorizarCuentaContableIPEJAL(key);
      if (saved) {
        const _data = await getCuentasContablesIPEJAL();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Área',
      dataIndex: 'area',
      key: 'area',
      width: 200,
      render: (_, record) => record?.area?.clave_y_nombre || ' ',
    },
    {
      titleText: 'Cuenta Contable',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 200,
      render: (_, record) => {
        const _cuenta_contable = record?.cuenta_contable;
        let clave_name = ' ';
        if (_cuenta_contable) clave_name = `${_cuenta_contable.clave_visible || _cuenta_contable.clave} - ${_cuenta_contable.nombre.trim()}`;
        return clave_name;
      },
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Percepciones de Configuración de IPEJAL`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="Validacion"
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="area"
                  label="Área"
                  hasFeedback
                  rules={rules.required}
                >
                  <TreeSelect
                    showSearch
                    treeNodeFilterProp="nombre"
                    treeData={areas}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="cuenta_contable"
                  label="Cuenta Contable"
                  rules={[{ required: true, message: 'Selecciona una cuenta contable' }]}
                  hasFeedback
                >
                  <TreeSelect
                    showSearch
                    allowClear
                    treeNodeFilterProp="title"
                    // treeDefaultExpandAll
                    style={{ width: '100%' }}
                    treeData={mapToTreeData(cuentasContables)}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Percepciones de Configuraciones de IPEJAL ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Percepciones de Configuraciones de IPEJAL ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Percepciones de Configuraciones de IPEJAL ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default CuentaContableIPEJAL;
